module.exports = __webpack_public_path__ + "img/merk-poster.2a55aefd.jpg";